<template>
	<div :class="{'canvas-opened':sidemenu}">
		<div class="dark-mark" @click="close()"></div>
		<aside id="sidebar-wrapper" class="custom-scrollbar offcanvas-sidebar">
			<button class="off-canvas-close" @click="close()"><img src="../../src/assets/imgs/login/close.png"></button>
			<div class="sidebar-inner" style="display: block;">
				<!--Categories-->
				<div class="sidebar-widget widget_categories mb-50 mt-30">
					<div class="widget-header-2 position-relative">
						<h5 class="mt-5 mb-15" style="text-transform">
							<div style="display: flex;align-items: center;">
								<div :style="{backgroundImage:'url('+user.avatar+')'}" class="avatar" style="margin-right: 1rem;"></div>
								<div style="display: flex;flex-direction: column;">
									<div style="cursor: pointer;" @click="touser(0)">{{user.username}}</div>
								</div>
							</div>
						</h5>
						
					</div>
					<div class="widget_nav_menu">
						<ul>
							<li class="cat-item cat-item-1" @click="touser(0)" style="display: flex;align-items: center;">
								<img src="../assets/imgs/user/Notifications.svg" class="edit-user-icon">Notifications
								<div style="display: flex;justify-content: flex-end;width: 100%;">
									<div style="border-radius: 50%;width: 1rem;height: 1rem;background-color: #f00;color: #fff;display: flex;align-items: center;
											justify-content: center;font-size: 0.6rem;" v-show="unreadcount">{{unreadcount}}</div>
								</div>
							</li>
							<li class="cat-item cat-item-1" @click="touser(1)">
								<img src="../assets/imgs/user/Topics.svg" class="edit-user-icon">Topics
							</li>
							<li class="cat-item cat-item-1" @click="touser(2)">
								<img src="../assets/imgs/user/Inquiry record.svg" class="edit-user-icon">Inquiry record
							</li>
							<li class="cat-item cat-item-1" @click="touser(3)">
								<img src="../assets/imgs/user/customization.png" class="edit-user-icon">Customization
							</li>
							<li class="cat-item cat-item-1" @click="touser(4)">
								<img src="../assets/imgs/user/Reservations.svg" class="edit-user-icon">Reservations
							</li>
							<li class="cat-item cat-item-1" @click="touser(5)">
								<img src="../assets/imgs/user/My Demands.svg" class="edit-user-icon">My Demands
							</li>
							<li class="cat-item cat-item-1" @click="touser(6)">
								<img src="../assets/imgs/user/Collections.svg" class="edit-user-icon">Collections
							</li>
							<li class="cat-item cat-item-1" @click="touser(7)">
								<img src="../assets/imgs/user/Followings.svg" class="edit-user-icon">Followings
							</li>
							<li class="cat-item cat-item-1" @click="touser(8)">
								<img src="../assets/imgs/user/Profile.png" class="edit-user-icon">Profile
							</li>
							<li class="cat-item cat-item-1" @click="signout">
								<img src="../assets/imgs/edit-user-icon6.png" class="edit-user-icon">Sign out
							</li>
						</ul>
					</div>
				</div>
			</div>
		</aside>
	</div>
</template>

<script>
		// import axios from 'axios'
		// import {baseUrl} from '../assets/js/public.js'
		export default {
			data() {
				return {
					unreadcount:0
				}
			},
			props:{
				sidemenu:false,
				user:null,
			},
			components: {
			},
			filters: {
	        },
			methods: {
				touser(t){
					this.$router.push({name:'user',query:{type:t}})
					this.$router.go()
				},
				close() {
					this.$bus.$emit('sidemenu', false)
				},
				signout(){
					localStorage.removeItem('token')
					localStorage.removeItem('user')
					// this.$router.go()
					this.$router.push({name:'home'})
					location.reload()
				},
				getunread(){
					this.request({
						method: 'get',
						url: '/gci/notification/unread'
					}).then(res => {
						this.unreadcount = res.data
					}).catch(error => {
						console.error(error.response)
					})
				},
			},
			mounted() {
				this.getunread()
			}
		}
</script>

<style lang="scss" scoped>
	li{list-style:none}
	.avatar{
		width: 2rem;height: 2rem;background-size: cover;background-position: center center;background-repeat: no-repeat;border-radius: 50%;;
	}
	.edit-user-li{
		display: flex;align-items: center;margin-top: 1rem;
	}
	.cat-item:hover{
		color:#00E8BE
	}
	.edit-user-li-left{
		display: flex;align-items: center;flex: 1;cursor: pointer;
	}
	.edit-user-icon{width: 1rem;height: 1rem;margin-right: 0.5rem;}
	.cat-item{
		cursor: pointer;
	}
</style>